<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>

    <header class="sdev-page-header">

        <div class="sdev-page-header-r1">

            <!-- LEFT -->
            <div class="sdev-page-header-c1">

                <h1 class="sdev-page-title">
                    {{ title }}
                </h1>

                <p v-if="subtitle" class="sdev-page-subtitle sdev-border-bottom">
                    {{ subtitle }}
                </p>

                <slot name="breadcrumb">

                    <nav v-if="breadcrumb?.length" class="sdev-page-header-breadcrumb sdev-text-xxs">

                        <a v-for="(item, index) in breadcrumb" :key="index"
                            class="sdev-page-header-breadcrumb-item sdev-breadcrumb-separator-classic" :href="item.to">
                            {{ item.label }}
                        </a>

                    </nav>

                </slot>

            </div>


            <!-- ACTIONS -->
            <div class="sdev-page-header-c3">

                <slot name="actions">

                    <div v-if="actions?.length" class="sdev-page-header-actions">

                        <BaseButton v-for="action in actions" :key="action.label" :variant="action.variant"
                            class="sdev-button" @click="emit('action', action)">
                            {{ action.label }}
                        </BaseButton>

                    </div>

                </slot>

            </div>

        </div>
    </header>

</template>


<script setup>

defineProps({

    title: String,
    subtitle: String,

    breadcrumb: Array,
    actions: Array

})

const emit = defineEmits(["action"])

</script>